import { render, staticRenderFns } from "./lcu-button.vue?vue&type=template&id=50a9e926&scoped=true&"
import script from "./lcu-button.vue?vue&type=script&lang=ts&"
export * from "./lcu-button.vue?vue&type=script&lang=ts&"
import style0 from "./lcu-button.vue?vue&type=style&index=0&id=50a9e926&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a9e926",
  null
  
)

export default component.exports